// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"2f1a3afe","121":"180cc408","126":"6a69b440","129":"ae81a02d","163":"6a841789","251":"a57c10ef","391":"6a4a0c07","420":"8c00059e","571":"d96889a4","606":"37a38965","693":"6bbc825d","767":"f0f7c5e5","916":"31f873b7"}[chunkId] + ".chunk.js";
};